import React, { useState } from 'react';
import {
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import ArchiveIcon from '@mui/icons-material/Archive';
import UnarchiveIcon from '@mui/icons-material/Unarchive';
import LinkIcon from '@mui/icons-material/Link';
import EditIcon from '@mui/icons-material/Edit';

const ReportActionMenu = ({
  report,
  onView,
  onArchive,
  onUnarchive,
  onCopyLink,
  onEdit,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpen = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleAction = (handler) => {
    handleClose();
    if (handler) handler(report);
  };

  const isArchived = report.status === 'archived';

  return (
    <>
      <IconButton size="small" onClick={handleOpen} aria-label="Open report actions">
        <MoreVertIcon fontSize="inherit" />
      </IconButton>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        <MenuItem onClick={() => handleAction(onView)}>
          <ListItemIcon>
            <OpenInNewIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="View report" />
        </MenuItem>
        <MenuItem onClick={() => handleAction(onEdit)}>
          <ListItemIcon>
            <EditIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Edit metadata" />
        </MenuItem>
        {isArchived ? (
          <MenuItem onClick={() => handleAction(onUnarchive)}>
            <ListItemIcon>
              <UnarchiveIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Unarchive" />
          </MenuItem>
        ) : (
          <MenuItem onClick={() => handleAction(onArchive)}>
            <ListItemIcon>
              <ArchiveIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Archive" />
          </MenuItem>
        )}
        <MenuItem onClick={() => handleAction(onCopyLink)}>
          <ListItemIcon>
            <LinkIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Copy link" />
        </MenuItem>
      </Menu>
    </>
  );
};

export default ReportActionMenu;
